import { useEffect } from "react";
import useReceipt from "../../../../hooks/useReceipt.jsx";
import Divider from "../../aesthetics/Divider.jsx";
import FormReceiptPrecintas from "../../form/FormReceiptPrecintas.jsx";
import Modal from "../Modal.jsx";

const ModalUpdateReceiptPrecintas = ({ isOpen, onClose, refetchTable, receiptId }) => {
  const { data, loading, error, refetch: refetchReceipt } = useReceipt(receiptId, false);

  useEffect(() => {
    if (isOpen && receiptId) {
      refetchReceipt(receiptId);
    }
  }, [isOpen, receiptId, refetchReceipt]);

  if (!isOpen) return null;
  if (loading) return <div>Cargando documento...</div>;
  if (error) return <div className="text-red-600">Error: {error.response.data.detail}</div>;
  if (!data) return <div>No se han encontrado el documento</div>;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div>
        <h1 className="font-bold">Precintas</h1>
        <span>Introduzca las precintas correspondientes al vuelo {data.local_reference_code}.</span>
      </div>
      <Divider />
      <FormReceiptPrecintas onClose={onClose} refetch={refetchTable} receipt={data} />
    </Modal>
  );
};
export default ModalUpdateReceiptPrecintas;
